export default "__VITE_ASSET__e6519d42__"